module.exports = __webpack_public_path__ + "static/media/icon-error-web-2.f4f74de6.svg";